<div class="summarize-composer">

  <!-- =====================================================
       CONTENT INPUT
  ====================================================== -->
  <div class="content-input-section">

    <div class="input-header">

      <div class="input-title">

        <div class="input-icon">
          <i class="pi pi-file-edit"></i>
        </div>

        <div class="input-title-content">
          <h4>Content to Summarize</h4>
          <p>
            Paste your content or upload a document to get started.
          </p>
        </div>

      </div>

      <span class="ai-badge">
        <i class="pi pi-sparkles"></i>
        AI Powered
      </span>

    </div>


    <!-- =================================================
         CONTENT FORM
    ================================================== -->
    <div id="autocomplete-wrapper">

      <form [formGroup]="summarizeForm">

        <div
          id="autocomplete-input"
          class="textarea-wrapper"
          [class.has-error]="
            submitted &&
            summarizeForm.controls['summary'].invalid &&
            summarizeForm.controls['summary'].hasError('required')
          "
        >

          <div class="textarea-label-row">
            <label for="inputField">
              Your content
            </label>

            <span class="required-label">
              Required
            </span>
          </div>

          <textarea
            #autoCompleteInput
            id="inputField"
            name="question"
            formControlName="summary"
            class="form-textarea"
            placeholder="Enter or paste your content here..."
            rows="7"
          ></textarea>


          <!-- Textarea Footer -->
          <div class="textarea-bottom">

            <span class="textarea-hint">
              <i class="pi pi-info-circle"></i>
              <span>
                Add enough context for a better summary
              </span>
            </span>

            <span class="character-count">
              {{ summarizeForm.get("summary")?.value?.length || 0 }}
              characters
            </span>

          </div>

        </div>


        <!-- =================================================
             VALIDATION
        ================================================== -->
        @if (
          submitted &&
          summarizeForm.controls['summary'].invalid &&
          summarizeForm.controls['summary'].hasError('required')
        ) {

          <div class="error-message">

            <i class="pi pi-exclamation-circle"></i>

            <span>
              Please enter some content to summarize.
            </span>

          </div>

        }

      </form>

    </div>

  </div>


  <!-- =====================================================
       COMPOSER FOOTER
  ====================================================== -->
  <div class="composer-footer">

    <!-- Upload -->
    <div class="upload-area">

      <input
        type="file"
        name="msg-file"
        id="uploadfile"
        hidden
        (change)="chooseUploadFile($event)"
        #elibraryFileInput
        accept=".doc,.docx,.pdf"
      />

      <button
        type="button"
        class="upload-button"
        (click)="elibraryFileInput.click()"
      >

        <span class="button-icon">
          <i class="pi pi-cloud-upload"></i>
        </span>

        <span class="button-content">
          <strong>Upload Document</strong>
          <small>PDF, DOC or DOCX</small>
        </span>

        <i class="pi pi-chevron-right upload-arrow"></i>

      </button>

    </div>


    <!-- Actions -->
    <div class="action-buttons">

      <button
        type="button"
        class="clear-button"
        [disabled]="summarizeForm.invalid"
        (click)="summarizeForm.reset()"
      >
        <i class="pi pi-times"></i>
        <span>Clear</span>
      </button>


      <button
        type="button"
        class="summary-button"
        [disabled]="summarizeForm.invalid"
        (click)="postSummary()"
      >

        <i class="pi pi-sparkles"></i>

        <span>
          Generate Summary
        </span>

        <i class="pi pi-arrow-right button-arrow"></i>

      </button>

    </div>

  </div>

</div>


<!-- =====================================================
     LOADING
====================================================== -->

<app-page-loader *ngIf="showPageLoader"></app-page-loader>

<!-- @if (showPaginateSpinner) {

  <div
    class="spinner-overlay"
    role="status"
    aria-live="polite"
    aria-label="Generating summary"
  >

    <div class="loading-card">

      <div class="loading-icon">
        <i class="pi pi-sparkles"></i>
      </div>

      <div class="loading-content">
        <strong>Generating summary...</strong>
        <span>
          AI is analyzing your content
        </span>
      </div>

      <progress-spinner></progress-spinner>

    </div>

  </div>

} -->
